"use strict";

var NO_AUTH_REQUIRED_URLS = ['auth/phone/login', 'auth/emailcode/extend', 'purchases/bundles/'];
module.exports = {
  NO_AUTH_REQUIRED_URLS: NO_AUTH_REQUIRED_URLS
};